import React, { useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import ClientsWidget from './clients-small-widget'
import NewSalesWidget from './sales-small-widget'
import DeliveriesWidget from './deliveries-small-widget'
import GoalsWidget from './goals-widget'
import ResponsesWidget from './responses-widget'
import RevenueWidget from './revenue-widget'
import DashboardOverviewRangeModal from './filter-modal'
import DashboardAddGoalModal from './add-goal-modal'
import DashboardEditGoalModal from './edit-goal-modal'
import { useDispatch, useSelector } from 'react-redux'
import { sendErrorNotification, sendSuccessNotification } from '../../universal/notifications/notifications'
import { resetFallbackMessage } from '../../../redux/actions/universal'
import { retrieveUserDetails } from '../../../redux/actions/user'
import { auth } from '../../../networking/firebase'
import { ToastContainer } from 'react-toastify'
import { setActivePage, setActiveChildPage } from '../../../redux/actions/active-page'
import { resetAddNewGoal, retrieveGoalDisplay, resetUpdateGoal } from '../../../redux/actions/overview'
import './style.scss'

const Index = () => {

    const dispatch = useDispatch()
    const modal = useSelector(state => state.overview.showModals)

    const errorFallbackMessage = useSelector(state => state.universal.errorNotification)
    const successFallbackMessage = useSelector(state => state.universal.successNotification)

    const addGoalStatus = useSelector(state => state.overview.addGoal.status)
    //const addGoalLoading = useSelector(state => state.overview.addGoal.loading)
    const addGoalError = useSelector(state => state.overview.addGoal.error)

    const deleteGoalStatus = useSelector(state => state.overview.deleteGoal.status)
    //const deleteGoalLoading = useSelector(state => state.overview.deleteGoal.loading)
    const deleteGoalError = useSelector(state => state.overview.deleteGoal.error)

    const updateGoalStatus = useSelector(state => state.overview.updateGoal.status)
    //const updateGoalLoading = useSelector(state => state.overview.updateGoal.loading)
    const updateGoalError = useSelector(state => state.overview.updateGoal.error)

    const goalFilter = useSelector(state => state.overview.fetchGoals.type)
    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)

    useEffect(() => {
		dispatch(setActivePage("overview"))
		dispatch(setActiveChildPage(null))
	})

    useEffect(() => {
        if(errorFallbackMessage){
            sendErrorNotification(errorFallbackMessage)
            dispatch(resetFallbackMessage())
            dispatch(retrieveUserDetails(auth.currentUser?.uid))
        }
        if(successFallbackMessage){
            sendSuccessNotification(successFallbackMessage)
            dispatch(resetFallbackMessage())
            dispatch(retrieveUserDetails(auth.currentUser?.uid))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [successFallbackMessage, errorFallbackMessage])

    useEffect(() => {
        if(addGoalStatus && addGoalStatus === "success"){
            sendSuccessNotification("Nytt mål ble lagt til.")
            dispatch(retrieveGoalDisplay({companyId: selectedCompany, filter: goalFilter}))
        }
        if(addGoalError){
            sendErrorNotification("Kunne ikke legge til nytt mål.")
            dispatch(resetAddNewGoal())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addGoalStatus, addGoalError])

    useEffect(() => {
        if(deleteGoalStatus && deleteGoalStatus === "success"){
            sendSuccessNotification("Målet ble slettet.")
            dispatch(retrieveGoalDisplay({companyId: selectedCompany, filter: goalFilter}))
        }
        if(deleteGoalError){
            sendErrorNotification("Kunne ikke slette nytt mål.")
            dispatch(resetAddNewGoal())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleteGoalStatus, deleteGoalError])

    useEffect(() => {
        if(updateGoalStatus && updateGoalStatus === "success"){
            sendSuccessNotification("Målet ble oppdatert.")
            dispatch(retrieveGoalDisplay({companyId: selectedCompany, filter: goalFilter}))
        }
        if(updateGoalError){
            sendErrorNotification("Kunne ikke oppdatere mål.")
            dispatch(resetUpdateGoal())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateGoalStatus, updateGoalError])

    return(
        <section className="dashboard-overview-section">
            <div className="inner-dashboard-overview-container">
                <Row className="upper-statistics-row">
                    <Col className="left-statistics-col">
                        <Row className="top-details-row">
                            <ClientsWidget/>
                            <NewSalesWidget/>
                            <DeliveriesWidget/>
                        </Row>
                        <Row className="primary-details-row">
                            <RevenueWidget/>
                        </Row>
                    </Col>
                    <Col className="right-details-col">
                        <Row className="pipeline-statistics">
                            <ResponsesWidget/>
                            <GoalsWidget/>
                        </Row>
                    </Col>
                </Row>
            </div>
            {modal.rangeModal ? <DashboardOverviewRangeModal/>:null}
            {modal.addGoalModal ? <DashboardAddGoalModal/>:null}
            {modal.editGoalModal ? <DashboardEditGoalModal/>:null}
            <ToastContainer/>
        </section>
    )
}

export default Index